import React from "react";
import PropTypes from "prop-types";

import AlmigButton from "../grundelemente/AlmigButton";
import InfoBlock from "../grundelemente/InfoBlock";
import InfoDateContainer from "../grundelemente/InfoDateContainer";
import InfoEmpty from "../grundelemente/InfoEmpty";
import InfoPanel from "../grundelemente/InfoPanel";

class StoerspeicherInfoPanel extends React.Component {
	static propTypes = {
		doUpdate: PropTypes.func.isRequired
		/*
		doDownload: PropTypes.func.isRequired,
		doReset: PropTypes.func.isRequired
		*/
	};

	constructor(props, context) {
		super(props, context);
		/*
		 * plumpe, aber ausreichend wirkungsvolle lösung:
		 * beim öffnen wird einmal geladen. :-)
		 * 
		 * hier gezielt kein automatischer refetch, weil man ja
		 * vielleicht mal nen eintrag länger lesen will, sind
		 * doch diverse daten damit verbunden.
		 */
		this.props.doUpdate();
	}

	render() {
		return (
			<InfoPanel>
				<InfoBlock>
					<AlmigButton i18n_key="Update" onClick={this.props.doUpdate}/>
				</InfoBlock>
				{/*
				<InfoBlock>
					<AlmigButton i18n_key="Reset" onClick={this.props.doReset} />
				</InfoBlock>
				<InfoBlock>
					<AlmigButton i18n_key="Download" onClick={this.props.doDownload} />
				</InfoBlock>
				*/}
				<InfoEmpty height="250px" />
				<InfoDateContainer />
			</InfoPanel>);
	}
}

export default StoerspeicherInfoPanel;
